export default __webpack_public_path__ + "static/media/test2.8e5abfbc.png";